import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  constructor() {}

  hasRole(currentRoleId: number, allowedRoles: number[]): boolean {
    return allowedRoles.includes(currentRoleId);
  }
}
